<template>
  <div v-if="i18nLoaded" class="main">
    <div class="side-bar">
      <Media :query="{ maxWidth: 1152 }">
        <SideBar :isWide="false" />
      </Media>
      <Media :query="{ minWidth: 1152 }" @media-enter="setWide(true)" @media-leave="setWide(false)">
        <SideBar :isWide="true" />
      </Media>
    </div>
    <div class="main-contents-container" :class="{ wide: isWide }">
      <div class="banner">
        <div class="banner__text">
          <div class="banner__text__notice">
            <IconInfo />
          </div>
          <div class="banner__text__notice">
            <div>{{ "banner.notice" | t }}</div>
          </div>
        </div>
        <div>
          <button class="banner__btn" @click="openAnalytics">{{ "banner.noticeBtn" | t }}</button>
        </div>
      </div>
      <section class="main-contents" :class="{ wide: isWide }">
        <UserInfo />
        <section class="section">
          <CommonHeader v-if="displayTitle" :title="title" :subTitle="subTitle">
            <template slot="leftElements">
              <slot name="leftElements" />
            </template>
            <template slot="rightElements">
              <slot name="rightElements" />
            </template>
          </CommonHeader>
          <slot name="content" />
        </section>
        <Footer />
        <AlanyticsBanner v-if="showBanner" @close="hideBanner" />
      </section>
    </div>
  </div>
</template>

<script>
import Media from "vue-media";
import CommonHeader from "@/components/shared/CommonHeader";
import SideBar from "@/components/shared/SideBar";
import UserInfo from "@/components/shared/UserInfo";
import Footer from "@/components/shared/Footer";
import AlanyticsBanner from "@/components/analyticsBanner";
import { mapGetters } from "vuex";
import { BANNER_SESSION_KEY, ANALYTICS_LINK } from "@/lib/constants";
import IconInfo from "@/assets/logos/icon-info.svg";

export default {
  components: {
    Media,
    SideBar,
    UserInfo,
    CommonHeader,
    Footer,
    AlanyticsBanner,
    IconInfo,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: "",
    },
    displayTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showBanner: false,
      isWide: window.innerWidth > 1152,
    };
  },
  computed: {
    ...mapGetters({
      i18nLoaded: "i18n/i18nLoaded",
    }),
  },
  mounted() {
    const showBanner = sessionStorage.getItem(BANNER_SESSION_KEY) || false;
    setTimeout(() => {
      if (!showBanner) {
        this.showBanner = true;
      }
    }, 2000);
  },
  methods: {
    setWide(isWide) {
      this.isWide = isWide;
    },
    hideBanner() {
      this.showBanner = false;
      sessionStorage.setItem(BANNER_SESSION_KEY, "false");
    },
    openAnalytics() {
      window.open(ANALYTICS_LINK, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  min-height: 100vh;

  .banner {
    width: 100%;
    height: 48px;
    background: #18c6b9;
    display: flex;
    justify-content: center;
    align-items: center;

    &__text {
      color: #fcfcfc;
      padding: 0 16px;
      box-sizing: border-box;
      font-weight: 700;
      font-size: 14px;
      line-height: 150%;
      display: flex;
      align-items: center;
      &__notice {
        margin-left: 5px;
        align-items: center;
        display: flex;
      }
    }

    &__btn {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding: 3.5px 14px;
      gap: 2px;
      background: #ffffff;
      border-radius: 100px;
      border: none;
      &:hover {
        cursor: pointer;
      }
    }
  }

  .side-bar {
    position: fixed;
    height: 100%;
  }

  .main-contents-container {
    width: 100%;
  }

  .main-contents {
    width: 100%;
    padding-left: 150px;

    .section {
      padding-top: 90px;
      padding-right: 78px;
    }

    &.wide {
      padding-left: 220px;
    }
  }
}
</style>
